import {
  Box, Button, Flex, FormControl, FormLabel, Input,
  Switch, Text, Textarea, useColorModeValue
} from '@chakra-ui/react'
import Card from 'components/Card/Card.js'
import CardBody from 'components/Card/CardBody.js'
import CardHeader from 'components/Card/CardHeader.js'
import { useFormik } from 'formik'
import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Select from 'react-select'
import { CREATE_WORKSHEET } from 'store/worksheets'
import { CLASS, SUBJECT } from 'variables/enumObject'
import * as Yup from 'yup'

function AddWorksheet() {
  const dispatch = useDispatch()
  const history = useHistory()
  const textColor = useColorModeValue('gray.700', 'white')
  const bgColor = useColorModeValue('#FFF', '#718096')
  const hoverColor = useColorModeValue('#CBD5E0', '#4A5568')
  const selectColor = useColorModeValue('#718096', '#1A202C')
  const pdfInputRef = useRef()

  const customStyles = {
    control: (styles) => ({
      ...styles,
      borderRadius: '15px',
      outline: '2px solid transparent',
      borderColor: '#E2E8F0',
      minHeight: '3rem',
      marginBottom: '24px'
    }),
    option: (styles, state) => ({
      ...styles,
      backgroundColor: state.isFocused ? hoverColor : state.isSelected ? selectColor : bgColor,
    }),
  }

  const validationSchema = Yup.object({
    name: Yup.string().required('บังคับกรอก')
  })

  const formik = useFormik({
    initialValues: {
      status: false,
      is_free: false,
      original_price: 0,
      sale_price: 0,
      is_new: false,
      is_recommended: false,
      is_bestseller: false,
    },
    onSubmit: (values, { setSubmitting }) => {
      const formData = new FormData()
      formData.append('name', values.name?.replace(/'/g, '’') || '')
      formData.append('subject', values.subject || '')
      formData.append('class', values.class || '')
      formData.append('description', values.description?.replace(/'/g, '’') || '')
      formData.append('url_image', values.url_image || '')
      formData.append('status', values.status)
      formData.append('is_free', values.is_free)
      formData.append('original_price', values.original_price)
      formData.append('sale_price', values.sale_price)
      formData.append('is_new', values.is_new)
      formData.append('is_recommended', values.is_recommended)
      formData.append('is_bestseller', values.is_bestseller)
      if (values.pdf_file) formData.append('pdf_file', values.pdf_file)

      dispatch(CREATE_WORKSHEET(formData))
        .then(() => {
          setSubmitting(false)
          history.push('/admin/worksheets')
        })
        .catch(() => setSubmitting(false))
    },
    validationSchema
  })

  return (
    <Flex direction='column' pt={{ base: '120px', md: '75px' }}>
      <form onSubmit={formik.handleSubmit}>
        <Card overflowX={{ sm: 'scroll', xl: 'hidden' }}>
          <CardHeader>
            <Flex justify='space-between' align='center' minHeight='60px' w='100%'>
              <Text fontSize='lg' color={textColor} fontWeight='bold'>เพิ่มใบงาน</Text>
              <Text fontSize='lg' color={textColor} fontWeight='bold'>
                <small>ปิดใช้งาน</small>
                <Switch size='lg' mx='10px' id='status' name='status'
                  onChange={e => formik.setFieldValue('status', e.target.checked)} />
                <small>เปิดใช้งาน</small>
              </Text>
            </Flex>
          </CardHeader>
          <CardBody p='20px'>
            <FormControl>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>ชื่อใบงาน</FormLabel>
              <Input
                fontSize='sm' ms='4px' borderRadius='15px' type='text' mb='24px' size='lg'
                name='name' onChange={formik.handleChange} onBlur={formik.handleBlur}
                value={formik.values.name || ''}
              />
              <Flex gap='5'>
                <Box flex='1'>
                  <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>วิชา</FormLabel>
                  <Select
                    options={SUBJECT} id='subject' name='subject' placeholder='เลือกวิชา'
                    styles={customStyles}
                    onChange={opt => formik.setFieldValue('subject', opt.label)}
                    onBlur={formik.handleBlur}
                  />
                </Box>
                <Box flex='1'>
                  <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>ชั้นเรียน</FormLabel>
                  <Select
                    options={CLASS} id='class' name='class' placeholder='เลือกชั้นเรียน'
                    styles={customStyles}
                    onChange={opt => formik.setFieldValue('class', opt.label)}
                    onBlur={formik.handleBlur}
                  />
                </Box>
              </Flex>
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>รายละเอียด</FormLabel>
              <Textarea
                id='description' name='description' fontSize='sm' ms='4px'
                borderRadius='15px' mb='24px' size='lg'
                onChange={formik.handleChange} onBlur={formik.handleBlur}
                value={formik.values.description || ''}
              />
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>URL รูปปก (ถ้ามี)</FormLabel>
              <Input
                fontSize='sm' ms='4px' borderRadius='15px' type='text' mb='24px' size='lg'
                name='url_image' onChange={formik.handleChange} onBlur={formik.handleBlur}
                value={formik.values.url_image || ''}
              />
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>อัพโหลดไฟล์ PDF</FormLabel>
              <Input
                ref={pdfInputRef}
                fontSize='sm' ms='4px' borderRadius='15px' type='file' mb='24px' size='lg'
                accept='application/pdf'
                onChange={e => formik.setFieldValue('pdf_file', e.currentTarget.files[0])}
              />
              <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>ประเภทใบงาน</FormLabel>
              <Text fontSize='lg' color={textColor} fontWeight='bold' mb='24px'>
                <small>เสียเงิน</small>
                <Switch size='lg' mx='10px' id='is_free' name='is_free'
                  onChange={e => formik.setFieldValue('is_free', e.target.checked)} />
                <small>ฟรี</small>
              </Text>
              <Flex gap='5'>
                <Box flex='1'>
                  <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>ราคาเต็ม</FormLabel>
                  <Input
                    fontSize='sm' ms='4px' borderRadius='15px' type='number' mb='24px' size='lg'
                    name='original_price' onChange={formik.handleChange} onBlur={formik.handleBlur}
                    value={formik.values.original_price}
                  />
                </Box>
                <Box flex='1'>
                  <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>ราคาที่ลด</FormLabel>
                  <Input
                    fontSize='sm' ms='4px' borderRadius='15px' type='number' mb='24px' size='lg'
                    name='sale_price' onChange={formik.handleChange} onBlur={formik.handleBlur}
                    value={formik.values.sale_price}
                  />
                </Box>
              </Flex>
              <Flex gap='5' mb='24px'>
                <Text color={textColor}>
                  <Switch mx='8px' id='is_new' isChecked={formik.values.is_new}
                    onChange={e => formik.setFieldValue('is_new', e.target.checked)} />
                  ใหม่ (New)
                </Text>
                <Text color={textColor}>
                  <Switch mx='8px' id='is_recommended' isChecked={formik.values.is_recommended}
                    onChange={e => formik.setFieldValue('is_recommended', e.target.checked)} />
                  แนะนำ (Recommended)
                </Text>
                <Text color={textColor}>
                  <Switch mx='8px' id='is_bestseller' isChecked={formik.values.is_bestseller}
                    onChange={e => formik.setFieldValue('is_bestseller', e.target.checked)} />
                  ขายดี (Bestseller)
                </Text>
              </Flex>
              <Button
                type='submit'
                bg='teal.300' fontSize='1rem' color='white' fontWeight='bold'
                w='100%' h='45' mb='24px'
                disabled={Object.keys(formik.errors).length !== 0}
                _hover={{ bg: 'teal.200' }}
                _active={{ bg: 'teal.400' }}
              >
                สร้างใบงาน
              </Button>
            </FormControl>
          </CardBody>
        </Card>
      </form>
    </Flex>
  )
}

export default AddWorksheet
